import React from 'react';
import PropTypes from 'prop-types';

import {
    Table
} from 'reactstrap';

import TableMovementItem from './TableMovementItem';
import Header from './TableHeader';
import TableTotal from './TableTotal';

const nf2 = new Intl.NumberFormat('es-MX', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
}); 

export default function TableReport({ data, totals, setColumnOrder, columnOrder,balance_initial }) {

    return (
        <div className="table-responsive" style={{position: 'relative', maxHeight: '500px'}}>
            <Table className="table mb-0 report-table table-bordered table-sm">
                <thead className='table-light'>
                    <TableTotal totals={totals} />
                    <Header totals={totals} setColumnOrder={ setColumnOrder } columnOrder={columnOrder}/>
                </thead>
                <tbody>
                    <tr>
                        <td colSpan={6}></td>
                        <td className="text-end"><b>{ nf2.format(balance_initial) }</b></td>
                    </tr>
                    { data.map((item,index) => (
                        <TableMovementItem key={ index } item={ item }/>
                    )) }
                </tbody>
            </Table>
        </div>
    );
}

TableReport.propTypes = {
    data: PropTypes.any,
    totals: PropTypes.object,
    setColumnOrder: PropTypes.func,
    columnOrder: PropTypes.object,
    balance_initial: PropTypes.any
};